// "use client";
// import React, { useState, useEffect } from "react";
// import { Navbar } from "@yardstick/shared-ui";
// import { useTheme } from "next-themes";
// import menuData from "./menuData";
// import Cookies from "js-cookie";
// import { useAuth } from "@/contexts/AuthContext";

// const Header = () => {
//   const { theme, setTheme } = useTheme();
//   const [access, setAccess] = useState(false);
//   const { token, setToken, setUser } = useAuth();

//   const handleLogout = () => {
//     localStorage.removeItem("yardstickUser");
//     Cookies.remove("yardstickAccessToken");
//     setToken(null);
//     setUser(null);
//     setAccess(false);
//   };

//   useEffect(() => {
//     setAccess(!!token);
//   }, [token]);

//   const updateMenu = () => {
//     const updatedMenu = JSON.parse(JSON.stringify(menuData));
//     const baseUrl = process.env.NEXT_PUBLIC_NAVBAR_URL || "";
//     if (access) {
//       updatedMenu.push({
//         id: 7,
//         title: "Edit Drafts",
//         path: `${baseUrl}/edit-drafts`,
//         newTab: false,
//       });
//       updatedMenu.push({
//         id: 8,
//         title: "Logout",
//         path: `${baseUrl}/`,
//         newTab: false,
//       });
//     } else {
//       updatedMenu.push({
//         id: 7,
//         title: "Login",
//         path: `${baseUrl}/auth/login`,
//         newTab: false,
//       });
//       updatedMenu.push({
//         id: 8,
//         title: "Sign Up",
//         path: `${baseUrl}/auth/register`,
//         newTab: false,
//       });
//     }
//     return updatedMenu;
//   };

//   return (
//     <Navbar
//       menuData={menuData}
//       theme={theme}
//       setTheme={setTheme}
//       access={access}
//       onLogout={handleLogout}
//       updateMenu={updateMenu}
//       navbarUrl={process.env.NEXT_PUBLIC_NAVBAR_URL || ""}
//     />
//   );
// };

// export default Header;

"use client";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import ThemeToggler from "./ThemeToggler";
import menuData, { getBaseMenuData, getProjectsMenuItem } from "./menuData";
import logo from "../../public/images/logo/yardsticklive_logo.png";
import { LogOut } from "lucide-react";
import Cookies from "js-cookie";

const Header = () => {
  const token = Cookies.get("yardstickAccessToken")
  const [dynamicMenuData, setDynamicMenuData] = useState(menuData);
  const [access, setAccess] = useState(null);
  const [projectCount, setProjectCount] = useState(0);
  const [baseMenuData, setBaseMenuData] = useState(getBaseMenuData());

  // Fetch project count
  useEffect(() => {
    const fetchProjectCount = async () => {
      try {
        const response = await fetch('/api/projects/count');
        const data = await response.json();
        if (data.success) {
          setProjectCount(data.count);
          
          // Update base menu data with or without projects based on count
          const base = getBaseMenuData();
          if (data.count >= 4) {
            // Insert projects menu item at position 3 (after Expertise)
            base.splice(3, 0, getProjectsMenuItem());
          }
          setBaseMenuData(base);
          setDynamicMenuData(base);
        }
      } catch (error) {
        console.error('Failed to fetch project count:', error);
      }
    };

    fetchProjectCount();
  }, []);

  // Navbar toggle
  const [navbarOpen, setNavbarOpen] = useState(false);
  const navbarToggleHandler = () => {
    setNavbarOpen(!navbarOpen);
  };

  // Sticky Navbar
  const [sticky, setSticky] = useState(false);
  const handleStickyNavbar = () => {
    if (window.scrollY >= 80) {
      setSticky(true);
    } else {
      setSticky(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleStickyNavbar);
  });

  // submenu handler
  const [openIndex, setOpenIndex] = useState(-1);
  const handleSubmenu = (index) => {
    if (openIndex === index) {
      setOpenIndex(-1);
    } else {
      setOpenIndex(index);
    }
  };

  const usePathName = usePathname();

  useEffect(() => {
    if (typeof window !== "undefined") {
      const haveAccess = token ? true : false;
      setAccess(haveAccess);
    }
  }, [access, token]);

  useEffect(() => {
    const updateMenu = () => {
      const updatedMenu = JSON.parse(JSON.stringify(baseMenuData));
      if (access) {
        updatedMenu.push({
          id: 7,
          title: "Edit Drafts",
          path: "/edit-drafts",
          newTab: false,
        });
        updatedMenu.push({
          id: 8,
          title: "Logout",
          path: "/",
          newTab: false,
        });
      } else {
        updatedMenu.push({
          id: 7,
          title: "Login",
          path: "/auth/login",
          newTab: false,
        });
        updatedMenu.push({
          id: 8,
          title: "Sign Up",
          path: "/auth/register",
          newTab: false,
        });
      }

      setDynamicMenuData(updatedMenu);
    };

    if (navbarOpen) {
      updateMenu();
    }

    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setDynamicMenuData((prevMenu) => prevMenu.slice(0, baseMenuData.length));
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [navbarOpen, access, baseMenuData]);

  const handleLogout = () => {
    localStorage.removeItem("yardstickUser");
    Cookies.remove("yardstickAccessToken");
    setAccess(false);
  };

  return (
    <>
      <header
        className={`header left-0 top-0 z-40 flex w-full items-center ${
          sticky
            ? "fixed z-[9999] bg-purple-50 !bg-opacity-80 shadow-sticky backdrop-blur-sm transition dark:bg-gray-dark dark:shadow-sticky-dark"
            : "absolute bg-transparent"
        }`}
      >
        <div className="container px-0">
          <div className="relative flex items-center justify-between">
            <div className="w-60 max-w-full px-4 xl:mr-12">
              <Link
                href="/"
                className={`header-logo flex w-full items-center gap-2 ${
                  sticky ? "py-5 lg:py-2" : "py-4"
                } `}
              >
                <Image
                  loading="eager"
                  src={logo}
                  alt="logo"
                  width={50}
                  height={50}
                  className="h-9 w-9 xl:h-12 xl:w-12"
                />
                <div
                  className={"block w-full text-[15px] md:text-xl lg:text-2xl"}
                >
                  Yardstick
                </div>
              </Link>
            </div>
            <div className="flex w-full items-center justify-between px-4">
              <div>
                <button
                  onClick={navbarToggleHandler}
                  id="navbarToggler"
                  aria-label="Mobile Menu"
                  className="absolute right-4 top-1/2 block translate-y-[-50%] rounded-lg px-3 py-[6px] ring-primary focus:ring-2 lg:hidden"
                >
                  <span
                    className={`relative my-1.5 block h-0.5 w-[30px] bg-black transition-all duration-300 dark:bg-purple-50 ${
                      navbarOpen ? " top-[7px] rotate-45" : " "
                    }`}
                  />
                  <span
                    className={`relative my-1.5 block h-0.5 w-[30px] bg-black transition-all duration-300 dark:bg-purple-50 ${
                      navbarOpen ? "opacity-0 " : " "
                    }`}
                  />
                  <span
                    className={`relative my-1.5 block h-0.5 w-[30px] bg-black transition-all duration-300 dark:bg-purple-50 ${
                      navbarOpen ? " top-[-8px] -rotate-45" : " "
                    }`}
                  />
                </button>
                <nav
                  id="navbarCollapse"
                  className={`navbar absolute right-0 z-30 w-[250px] rounded border-[.5px] border-body-color/50 bg-purple-50 px-6 py-4 duration-300 dark:border-body-color/20 dark:bg-dark lg:visible lg:static lg:w-auto lg:border-none lg:!bg-transparent lg:p-0 lg:opacity-100 ${
                    navbarOpen
                      ? "visibility top-full opacity-100"
                      : "invisible top-[120%] opacity-0"
                  }`}
                >
                  <ul className="block lg:flex lg:space-x-12">
                    {dynamicMenuData.map((menuItem, index) => (
                      <li key={index} className="group relative">
                        {menuItem.path ? (
                          <Link
                            href={menuItem.path}
                            className={`flex py-2 text-base lg:mr-0 lg:inline-flex lg:px-0 lg:py-6 ${
                              usePathName === menuItem.path
                                ? "text-primary dark:text-white"
                                : "text-dark hover:text-primary dark:text-white/70 dark:hover:text-white"
                            }`}
                            onClick={
                              menuItem.title === "Logout"
                                ? handleLogout
                                : () => {}
                            }
                            title={menuItem.title === "Logout" ? "Logout" : ""}
                          >
                            {menuItem.title === "Logout" ? (
                              <LogOut className="h-5 w-5" />
                            ) : (
                              menuItem.title
                            )}
                          </Link>
                        ) : (
                          <>
                            <p
                              onClick={() => handleSubmenu(index)}
                              className="flex cursor-pointer items-center justify-between py-2 text-base text-dark group-hover:text-primary dark:text-white/70 dark:group-hover:text-white lg:mr-0 lg:inline-flex lg:px-0 lg:py-6"
                            >
                              {menuItem.title}
                              <span className="pl-3">
                                <svg width="25" height="24" viewBox="0 0 25 24">
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M6.29289 8.8427C6.68342 8.45217 7.31658 8.45217 7.70711 8.8427L12 13.1356L16.2929 8.8427C16.6834 8.45217 17.3166 8.45217 17.7071 8.8427C18.0976 9.23322 18.0976 9.86639 17.7071 10.2569L12 15.964L6.29289 10.2569C5.90237 9.86639 5.90237 9.23322 6.29289 8.8427Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                            </p>
                            <div
                              className={`submenu relative left-0 top-full rounded-sm bg-purple-50 transition-[top] duration-300 group-hover:opacity-100 dark:bg-dark lg:invisible lg:absolute lg:top-[110%] lg:block lg:w-[250px] lg:p-4 lg:opacity-0 lg:shadow-lg lg:group-hover:visible lg:group-hover:top-full ${
                                openIndex === index ? "block" : "hidden"
                              }`}
                            >
                              {menuItem.submenu.map((submenuItem, index) => (
                                <Link
                                  href={submenuItem.path}
                                  key={index}
                                  className="block rounded py-2.5 text-sm text-dark hover:text-primary dark:text-white/70 dark:hover:text-white lg:px-3"
                                >
                                  {submenuItem.title}
                                </Link>
                              ))}
                            </div>
                          </>
                        )}
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
              <div className="flex items-center justify-end pr-16 lg:pr-0">
                {access ? (
                  <>
                    <Link
                      href="/edit-drafts"
                      className="hidden px-4 py-3 text-base font-medium text-dark hover:opacity-70 dark:text-white lg:block"
                    >
                      Edit Drafts
                    </Link>
                    <Link
                      href="/"
                      className="hidden px-4 py-3 text-base font-medium text-dark hover:opacity-70 dark:text-white lg:block"
                      onClick={handleLogout}
                      title="Logout"
                    >
                      <LogOut className="h-5 w-5" />
                    </Link>
                  </>
                ) : (
                  <>
                    <Link
                      href="/auth/login"
                      className="hidden px-7 py-3 text-base font-medium text-dark hover:opacity-70 dark:text-white lg:block"
                    >
                      Sign In
                    </Link>
                    <Link
                      href="/#contact"
                      className="ease-in-up hidden rounded bg-primary px-8 py-3 text-base font-medium text-white shadow-btn transition duration-300 hover:bg-opacity-90 hover:shadow-btn-hover md:px-9 lg:block lg:px-6 xl:px-9"
                    >
                      Let&apos;s Talk
                    </Link>
                  </>
                )}
                <div>
                  <ThemeToggler />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
